import React from "react"
import { Grid } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"

import useStyles from "@/skeletons/Admin/WABAUsageStatementSkeleton/styles"

const cardKeys = [0, 1, 2]
const tableRowKeys = [0, 1, 2, 3, 4]

const WABAUsageStatementSkeleton: React.FC = () => {
	const classes = useStyles()

	return (
		<Grid container direction="column" spacing={5}>
			<Grid item>
				<div className={classes.cardsRow}>
					{cardKeys.map(key => (
						<div key={key} className={classes.card}>
							<Skeleton className={classes.skeleton} height={16} width={140} />
							<Skeleton className={classes.skeleton} height={36} width={80} style={{ marginTop: 8 }} />
						</div>
					))}
				</div>
			</Grid>

			<Grid item>
				<div className={classes.section}>
					<Skeleton className={classes.skeleton} height={20} width={180} />
					<Skeleton className={classes.skeleton} height={14} width={220} style={{ marginTop: 4 }} />
					<Skeleton className={classes.skeleton} height={260} width="100%" style={{ marginTop: 16 }} />
				</div>
			</Grid>

			<Grid item>
				<div className={classes.tableSection}>
					<Skeleton className={classes.skeleton} height={20} width={200} style={{ marginBottom: 16 }} />
					{tableRowKeys.map(key => (
						<Skeleton key={key} className={classes.skeleton} height={40} style={{ marginBottom: 4 }} />
					))}
				</div>
			</Grid>
		</Grid>
	)
}

export default WABAUsageStatementSkeleton
